/* eslint-disable no-unused-vars */
import { BANK_ID } from "./consts";
import { BankIdMessageEvent } from "../../../models";
import { isValidJSON } from "../app/utils";

interface listenForBankIdEventsProps {
    onCode: (code: string) => void;
    onError: (error: string, description: string) => void;
    onNotFound?: (data: BankIdMessageEvent) => void;
}

export const listenForBankIdEvents = ({
    onCode = () => undefined,
    onError = () => undefined,
    onNotFound = () => undefined,
}: listenForBankIdEventsProps) => {
    window.addEventListener(
        "message",
        function listener(event) {
            // TODO: We should probably use event.origin to verify the url of message poster
            if (isValidJSON(event.data)) {
                const parsedData = JSON.parse(event.data) as BankIdMessageEvent;

                if (parsedData.id === BANK_ID.ERROR.ID) {
                    onError(parsedData.error, parsedData.description);
                } else if (parsedData.id === BANK_ID.CODE.ID) {
                    onCode(parsedData.code);
                    window.removeEventListener("message", listener);
                } else {
                    onNotFound(parsedData);
                }
            }
        },
        false,
    );
};

export const pending = (actionType: string) => `${actionType}_PENDING`;
export const fulfilled = (actionType: string) => `${actionType}_FULFILLED`;
export const rejected = (actionType: string) => `${actionType}_REJECTED`;
